import { residentQueryOptions } from "@/api/residents.api";
import { ResidentDetail } from "@/components/residents/resident-detail";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/residents/$id")({
  component: () => {
    const { id } = Route.useParams();
    const residentQuery = useSuspenseQuery(residentQueryOptions(id));
    return <ResidentDetail resident={residentQuery.data} />;
  },
});
